import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { ProfileRedirectComponent } from './profile-redirect.component';
import { ReportFillComponent } from './features/reports/report-fill.component';
import { ReportsComponent } from './features/reports/reports.component';

export const routes: Routes = [
  {
    path: '',
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: ReportsComponent,
        data: { titleKey: 'reports.pageTitle' }
      },
      {
        path: 'reports',
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: ReportsComponent,
            data: { titleKey: 'reports.pageTitle' }
          },
          {
            path: 'fill/:reportId',
            component: ReportFillComponent,
            data: { titleKey: 'reports.fill.breadcrumbFill' }
          }
        ]
      },
      {
        path: 'profile',
        pathMatch: 'full',
        component: ProfileRedirectComponent
      },
      {
        path: '**',
        redirectTo: 'reports'
      }
    ]
  }
];
